import React, {Component} from 'react';
import {compose} from "redux";
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import PropTypes from 'prop-types';
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import {Button, InputAdornment, MenuItem, Select, TextField, Tooltip, Snackbar} from "@material-ui/core";
import BlockAtm from "../../../../../atomic/Block/Block";
import ColAtm from "../../../../../atomic/Col/Col";
import LabelAtm from "../../../../../atomic/Label/Label";
import InputAtm from "../../../../../atomic/Input/Input";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import ButtonAtm from "../../../../../atomic/Button/Button";
import AppBar from "@material-ui/core/AppBar/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import ReactHtmlParser from 'react-html-parser';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {convertAccentedCharacters, getRoomChildAges, isDefined, viewTypeReturn} from '../../../../../../utils';
import {bedGroupCoundCreateData} from '../../../../../../utils'
import {Alert, createFilterOptions} from "@material-ui/lab";
import {roomOccupancyCodeCreate} from "../../../../../../utils"
import {SelectValidator, TextValidator, ValidatorForm} from "react-material-ui-form-validator";
import Grid from "@material-ui/core/Grid";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { openAI, clearOpenAI } from '../../../../../../redux/actions/General/OpenAI/openAIActions';
import { getLanguages } from '../../../../../../redux/actions/languageActions';
import axios from 'axios';
import { OPEN_AI } from '../../../../../../constants/api.constants';
import { getAppLang, getUserToken, getProperty } from '../../../../../../utils';
import { propertyProducts } from '../../../../../../redux/actions/propertyProductsActions';

let t=null

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`room-rate-tabpanel-${index}`}
            aria-labelledby={`room-rate-tab-${index}`}
            {...other}
        >
            {value === index && <Box>{children}</Box>}
        </Typography>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `room-rate-tab-${index}`,
        'aria-controls': `room-rate-tabpanel-${index}`,
    };
}

function a12yProps(index) {
    return {
        id: `room-rate-tab-${index}`,
        'aria-controls': `room-rate-tabpanel-${index}`,
    };
}

const ages = getRoomChildAges();

class EditRoomForm extends Component {

    constructor(props){
        super(props);
        this.handleAddField = this.handleAddField.bind(this);
        this.roomOccupancyAdult = this.roomOccupancyAdult.bind(this);
        this.handleDeleteFields = this.handleDeleteFields.bind(this);
        t = props.t;
        if(this.props.roomInfo){

            this.state = {
                value : 0,
                roomId : this.props.roomInfo.id,
                roomTypeValue: this.props.roomInfo.room_type_id,
                roomName: this.props.roomInfo.name,
                maxRoomOccupancy : this.props.roomInfo.max_occupancy,
                maxAdults : this.props.roomInfo.max_adult,
                maxChildren : this.props.roomInfo.max_child,
                room_size : this.props.roomInfo.room_size,
                room_size_type : this.props.roomInfo.room_size_type,
                room_count : this.props.roomInfo?.room_count,
                room_type_count : this.props.roomInfo?.room_type_count,
                bathroom_count : this.props.roomInfo?.bathroom_count,
                toilet_count : this.props.roomInfo?.toilet_count,
                lounge_count : this.props.roomInfo?.lounge_count,
                max_child_number : String(this.props.roomInfo?.max_child_number),
                roomViewType: this.props.roomInfo.property_room_view_mapping.length >0 ? [ ...this.props.roomInfo.property_room_view_mapping.map( roomView => roomView.id) ] : [],
                options : bedGroupCoundCreateData(this.props.roomInfo.property_room_bed_group),
                exclude_occupancy : this.props.roomInfo.exclude_occupancy !== null ? this.props.roomInfo.exclude_occupancy : [] ,
                occupancyCode : [],
                description : this.props.roomInfo.description ? this.props.roomInfo.description : {},
                descriptionCharCount : Object.keys(this.props.roomInfo.description).length > 0  ? this.props.roomInfo.description.map(value =>{
                    return value.description === null ? 0 : value.description.length
                }) : [],
                descriptionMaxCharCount : 1000,
                tabValue : 0,
                connected_rooms : this.props.roomInfo?.property_room_connected,
                is_connected_room : this.props.roomInfo?.is_connected_room,
                is_connected_room_price : this.props.roomInfo?.is_connected_room_price,
                is_connected_room_availability : this.props.roomInfo?.is_connected_room_availability,
                occupancy_lock : this.props.roomInfo?.occupancy_lock === 0 ? null : this.props.roomInfo?.occupancy_lock,
                status : this.props.roomInfo?.status,
                translateLoading: false,
                isTranslateMode: false,
                translateSourceLang: "",
                showSnackbar: false,
            }
        }
    }


    handleTabChange = ( event, newValue ) => {
        this.setState( {tabValue : newValue});
    };

    handleRoomAdd = () => {
        const param = this.state;
        this.props.updateRoom(param);
    };

    handleChange = ( event, newValue ) => {
        this.setState( {value : newValue});
    };

    handleChangeFields = (e) => {
        this.setState({
            [e.target.name]: isDefined(e.target.value) ? e.target.value : null
        });
    };

    handleChangeRoomType = (e) => {
        this.setState({roomTypeValue:e.target.value});
    };

    handleChangeBedType = (id,subId) =>(e) => {
        let tempOptions = this.state.options;
        tempOptions[id][subId].bed_type_id = e.target.value;
        tempOptions[id][subId].bed_type_count = 1;
        this.setState({
            options: tempOptions,
        });
    };

    handleAddOptions = () => {
        this.setState({
            options: this.state.options.concat(
                [
                    [
                        {
                            bed_type_count:"",
                            bed_type_id: "",
                        }
                    ]
                ]
            )
        });
    };

    handleAddField = id => evt => {

        let tempOptions = this.state.options;
        tempOptions[id] = this.state.options[id].concat(
            {
                bed_type_count:"",
                bed_type_id: "",
            }
        );

        this.setState({
            options: tempOptions,
        });

    };

    handleDeleteOptionField = id => (e) => {
        let tempOptions = this.state.options;
        if(id > 0){
            tempOptions.splice(id,1);
            this.setState({
                options: tempOptions,
            });
        }
    }

    componentDidMount() {
        if(this.state.occupancyCode.length === 0 )
        {
            let occupancyCode = roomOccupancyCodeCreate(this.state.maxAdults,this.state.maxChildren,this.state.maxRoomOccupancy )
            this.setState({
                occupancyCode
            })
        }
        this.props.getLanguages();
        /*this.setState({
            ...this.state, connected_rooms: this.props.roomInfo?.property_room_connected.map(fileItem => fileItem.connected_room_id)
        });*/
        if (!this.props.propertyProductsReducer?.get_products) {
            this.props.propertyProducts();
        }
    }

    roomOccupancyAdult() {

        /**
         *  A = adult
         *  C = child
         */
        let adultCode = 'A';
        let childCode = 'C';

        let adultIcons = '<i class="room-type-icon fas fa-male" />';
        let childIcons = '<i class="room-type-icon fas fa-child" />';


        let allCode = [];
        for (let i = 1; i <= this.state.maxAdults; i++) {

            for (let j = 0; j <= this.state.maxChildren; j++) {
                let code = '';
                let appendIcon = '';
                if ((i + j) > this.state.maxRoomOccupancy) continue;

                for (let k = 0; k < i; k++) code +=  adultCode;
                for (let l = 0; l < j; l++) code +=  childCode;

                for (let k = 0; k < i; k++) appendIcon += '<div>'+ adultIcons+ '</div>';
                for (let l = 0; l < j; l++) appendIcon += '<div>'+ childIcons +'</div>';

                allCode.push({code:code,icon:appendIcon})
            }
        }

        this.setState({
            occupancyCode : allCode
        })
    }

    handleChangeOccupancy = (e) => {
        this.setState({
            [e.target.name] : e.target.value
        }, () => this.roomOccupancyAdult() )
    }

    handleChangeExcludeOccupancy = (selectedOccupancy) => {

        if ( selectedOccupancy !== undefined && selectedOccupancy !== null ) {

            let list = [...this.state.exclude_occupancy];
            let index = list.findIndex(value => value === selectedOccupancy );

            if(index !== -1 )
            {
                list.splice(index,1);
                this.setState({
                    exclude_occupancy : list
                } )
            }else{
                list.push(selectedOccupancy);
                this.setState({
                    exclude_occupancy : list
                })
            }
        }
    }

    handleDeleteFields (subId, id) {

        let tempOptions = this.state.options;

        let index =  subId
        if (index !== -1) {
            tempOptions[id].splice(subId,1);
            this.setState({
                options: tempOptions,
            });
        }
    };

    handleChangeRoomViewType=(e,value) => {
        let selectedValues =  value.map((item) => {
            return item.id
        })
        this.setState({
            roomViewType: selectedValues
        })
    }

    onSubmit = (e) => {
        e.preventDefault();
        this.setState( {value : 1});
    };

    handleChangeCharCount = index => (e) => {

        let tempCount = this.state.descriptionCharCount;
        tempCount[index] = e.target.value.length;

        this.setState({
            descriptionCharCount:tempCount
        });

        let values = this.state.description;
        values[index]["description"] = e.target.value;

    };

    handleChangeMaxChildFields = (e, value) => {
        this.setState({max_child_number: value})
    };

    selectedRooms = (rooms) => {
        let tempRooms = [];
        tempRooms.push(rooms);
        this.setState({
            ...this.state, connected_rooms: tempRooms[0].map(fileItem => fileItem.id)
        });
    };

    connectedRooms = () => {
        this.setState({
            connected_rooms: this.props.roomInfo?.property_room_connected.map(connectedRooms => connectedRooms.connected_room_id)
        });
    };

    handleOccupancyLock = (e) => {

        if (e.target.checked) {
            this.setState({
                occupancy_lock: 1
            });
        } else {
            this.setState({
                occupancy_lock: null
            });
        }
    };
    
    changeStatus = (e) => {
        this.setState({
            status: e.target.value
        });
    };

    handleTranslate = (index, langCode) => async (e) => {
        const currentDesc = this.state.description.find(d => d.language_code === langCode);
        if (!currentDesc?.description || currentDesc.description.trim() === "") return;

        this.setState({ translateLoading: true });

        const sourceLangName = (this.props.languageList || []).find(lang => lang?.code === langCode)?.name || langCode;
        const targetLangs = (this.props.languageList || [])
            .map(lang => ({ code: lang?.code, name: lang?.name }))
            .filter(lang => lang.code && lang.code !== langCode);

        const headers = {
            'Content-Type': 'application/json',
            'authToken': getUserToken(),
            'language': getAppLang(),
        };

        const makeRequest = (targetLang) => {
            const body = {
                params: {
                    property_id: getProperty(),
                    query: {
                        model: "gpt-4.1-mini",
                        response_format: { type: "json_object" },
                        messages: [
                            {
                                role: "system",
                                content: "Sen profesyonel bir çevirmensin. Cevabını SADECE JSON formatında ver, tek bir key olsun: dil kodu (örn: {\"en\": \"...\"})."
                            },
                            {
                                role: "user",
                                content: `Aşağıdaki ${sourceLangName} dilindeki metni ${targetLang.name} diline çevir. Metin: "${currentDesc.description}". Çeviriyi JSON formatında ver, key olarak "${targetLang.code}" kullan.`
                            }
                        ]
                    }
                }
            };
            return axios.post(OPEN_AI, body, { headers })
                .then(res => res.data.data)
                .catch(() => null);
        };

        try {
            const results = await Promise.all(targetLangs.map(lang => makeRequest(lang)));
            const merged = {};
            results.forEach(result => {
                if (result && typeof result === 'object') Object.assign(merged, result);
            });
            this.handleTranslateResponse(merged, langCode);
        } finally {
            this.setState({ translateLoading: false });
        }
    };

    handleTranslateResponse = (aiData, sourceLangCode) => {
        let updatedDescriptions = this.state.description.map(desc => ({ ...desc }));
        Object.keys(aiData || {}).forEach(lang => {
            if (lang !== sourceLangCode) {
                const idx = updatedDescriptions.findIndex(d => d.language_code === lang);
                if (idx !== -1 && aiData[lang]) {
                    updatedDescriptions[idx].description = aiData[lang];
                }
            }
        });
        this.setState({
            description: updatedDescriptions,
            descriptionCharCount: updatedDescriptions.map(d => d.description ? d.description.length : 0),
            showSnackbar: true
        });
        // this.props.clearOpenAI();
    };

    handleCloseSnackbar = () => {
        this.setState({ showSnackbar: false });
    };

    render() {
        const {value,roomTypeValue, occupancyCode, is_connected_room, is_connected_room_price, is_connected_room_availability, connected_rooms, status, translateLoading, showSnackbar} = this.state;
        const {allRoomTypes} = this.props;
        const HtmlTooltip = (Tooltip);

        const sortedDescriptions = this.state.description.map((item, idx) => ({ ...item, originalIndex: idx })).sort((a, b) => {
            if (a?.language_code === "tr") return -1;
            if (b?.language_code === "tr") return 1;
            if (a?.language_code === "en") return -1;
            if (b?.language_code === "en") return 1;
            return a?.language_code.localeCompare(b?.language_code);
        });

        const contentProduct = !this.props.propertyProductsReducer?.fetching &&
            isDefined(this.props.propertyProductsReducer?.get_products)
                ? Object.values(this.props.propertyProductsReducer.get_products.data).find(item => item.route === "content")
                : null;
        const showAIContent = isDefined(contentProduct) &&
            isDefined(contentProduct.parameters) &&
            (contentProduct.parameters.length === 0 || contentProduct.parameters.some(p => p?.product_parameter_id === 102 && p?.is_selected === 1));

        const descriptionList = sortedDescriptions.map((title, index) => {
            const hasDescription = title?.description && title?.description.trim() !== "";
            return (
                <TabPanel value={this.state.tabValue} index={index} className="w-100" key={title.language_code}>
                    {showAIContent && (
                        <Box display="flex" justifyContent="flex-end">
                            <ButtonAtm
                                size="small"
                                variant="outlined"
                                onClick={this.handleTranslate(title.originalIndex, title.language_code)}
                                className="mt-12 create-with-ai"
                                startIcon={
                                    translateLoading ?
                                        <i style={{fontSize: "16px", marginLeft: "8px"}} className="fas fa-spinner-third fa-spin"></i>
                                        :
                                        <svg fill="#d71f26" style={{width: "1.5rem", height: "1rem", fontSize: 20}} viewBox="0 0 52 52" data-name="Layer 1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"><path d="M39,18.67H35.42l-4.2,11.12A29,29,0,0,1,20.6,24.91a28.76,28.76,0,0,0,7.11-14.49h5.21a2,2,0,0,0,0-4H19.67V2a2,2,0,1,0-4,0V6.42H2.41a2,2,0,0,0,0,4H7.63a28.73,28.73,0,0,0,7.1,14.49A29.51,29.51,0,0,1,3.27,30a2,2,0,0,0,.43,4,1.61,1.61,0,0,0,.44-.05,32.56,32.56,0,0,0,13.53-6.25,32,32,0,0,0,12.13,5.9L22.83,52H28l2.7-7.76H43.64L46.37,52h5.22Zm-15.3-8.25a23.76,23.76,0,0,1-6,11.86,23.71,23.71,0,0,1-6-11.86Zm8.68,29.15,4.83-13.83L42,39.57Z"/></svg>
                                }
                                style={{borderRadius: "8px", color: "#000", textTransform: "none"}}
                                buttontext={t('btn-translate')}
                                disabled={!hasDescription || translateLoading}
                            />
                        </Box>
                    )}
                    <TextField
                        name={title.language_code}
                        type="text"
                        variant="outlined"
                        className={showAIContent ? 'text-capitalize desc-field' : 'text-capitalize mt-20' }
                        onChange={this.handleChangeCharCount(title.originalIndex)}
                        value={this.state.description[title.originalIndex]?.description || ""}
                        label={ t('enw-input-description') + " - " + title.language_code }
                        multiline={true}
                        fullWidth
                        required={false}
                        rows={2}
                        inputProps={{maxLength : this.state.descriptionMaxCharCount}}
                    />
                    <div style={{ width: '100%'}}>
                        <p style={{ float : 'right'}}> { this.state.descriptionCharCount[title.originalIndex] }/ {this.state.descriptionMaxCharCount}</p>
                    </div>
                </TabPanel>
            );
        });

        const descriptionTabs = sortedDescriptions.map((title, value) => {
            const flag = <Grid container className="brand-desc-flag" spacing={1}>
                            <Grid item sm={3}>
                                <img src={`${process.env.PUBLIC_URL}/assets/img/language/${title.language_code}.svg`} title={title.language_code} alt={title.language_code} />
                            </Grid>
                            <Grid item sm={2}>
                                {title.language_code}
                            </Grid>
                        </Grid>
            return (
                <Tab label={ flag } {...a12yProps(value)} key={title.language_code} />
            );
        });

        return (
            <div>
                <ValidatorForm onSubmit={this.onSubmit} ref={"form"} onError={errors => console.log(errors)}>
                    <AppBar className="room-rate-tab-title" position="static">
                        <Tabs className="room-rate-tabFont" value={value} onChange={this.handleChange} aria-label="room-rate-tab">
                            <Tab label={ t('enw-room-rooms-modal-tab-room_type') } {...a11yProps(0)} />
                            <ButtonAtm type='submit' className={value === 1 ? "bed-type-title" : "passive-tab"} buttontext={ t('enw-room-rooms-modal-tab-bed_type') } {...a11yProps(1)} />
                        </Tabs>
                    </AppBar>
                    <TabPanel value={value} index={0}>
                        <ColAtm xs={12} className="select-room-types">
                            <Grid container spacing={3}>
                                <ColAtm xs={12} md={4} className="form-group">
                                    <SelectValidator
                                        value={roomTypeValue}
                                        onChange={this.handleChangeRoomType}
                                        className="form-control"
                                        variant="outlined"
                                        fullWidth
                                        label={ t('enw-input-room-type') }
                                        validators={['required']}
                                        errorMessages={[ t("enw-notification_this_is_required") ]}
                                    >
                                        {
                                            allRoomTypes.sort((a, b) => convertAccentedCharacters(t(a.language_key)) > convertAccentedCharacters(t(b.language_key)) ? 1:-1).map( (roomType) => (
                                                <MenuItem value={roomType.id} description="Example Room">
                                                    { t(roomType.language_key) }
                                                </MenuItem>
                                            ))
                                        }
                                    </SelectValidator>
                                </ColAtm>
                                <ColAtm xs={12} md={4}>
                                    <TextValidator
                                        id="roomTypeCount"
                                        name="room_type_count"
                                        value={this.state.room_type_count}
                                        placeholder={ t('enw-input-room_type_count') }
                                        label={ t('enw-input-room_type_count') }
                                        variant="outlined"
                                        onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9]/g, '') }}
                                        fullWidth
                                        autoComplete="off"
                                        onChange={this.handleChangeFields}
                                        validators={['minNumber:1', 'maxNumber:999','required']}
                                        errorMessages={[ 'minNumber 1', 'maxNumber 999',t("enw-notification_this_is_required")]}
                                    />
                                </ColAtm>
                                <ColAtm xs={12} md={4} >
                                    <SelectValidator
                                        name="room_status"
                                        className="room-status-input"
                                        variant="outlined"
                                        fullWidth
                                        label={ t('enw-input-status') }
                                        value={status}
                                        onChange={this.changeStatus}
                                        // validators={['required']}
                                        // errorMessages={[t("enw-notification_this_is_required")]}
                                    >
                                        <MenuItem value={1}>{ t('enw-input-active') }</MenuItem>
                                        <MenuItem value={0}>{ t('enw-input-inactive') }</MenuItem>
                                    </SelectValidator>
                                </ColAtm>
                            </Grid>
                            <Grid container spacing={3}>
                                <ColAtm xs={12} md={6}>
                                    <InputAtm
                                        name="roomName"
                                        variant="outlined"
                                        placeholder={ t('enw-input-room_name') }
                                        label={ t('enw-input-room_name') }
                                        fullWidth
                                        value={this.state.roomName}
                                        onChange={this.handleChangeFields}
                                    />
                                </ColAtm>
                                <ColAtm xs={12} md={3}>
                                    <TextValidator
                                        id="roomSize"
                                        name="room_size"
                                        value={this.state.room_size}
                                        placeholder={ t('enw-input-room_size') }
                                        label={ t('enw-input-room_size') }
                                        variant="outlined"
                                        fullWidth
                                        onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9-]/g, '') }}
                                        autoComplete="off"
                                        onChange={this.handleChangeFields}
                                        validators={['required']}
                                        errorMessages={ [ t("enw-notification_this_is_required") ] }
                                    />
                                </ColAtm>
                                <ColAtm className="select-width" xs={12} md={3}>
                                    <SelectValidator
                                        name="room_size_type"
                                        value={this.state.room_size_type}
                                        onChange={this.handleChangeFields}
                                        className="form-control"
                                        variant="outlined"
                                        fullWidth
                                        label={ t('enw-input-room_size_type') }
                                        validators={['required']}
                                        errorMessages={[t("enw-notification_this_is_required")]}
                                    >
                                        {
                                            Object.keys(this.props.roomSizeTypes).length > 0 ? this.props.roomSizeTypes.sort((a, b) => convertAccentedCharacters(t(a.language_key)) > convertAccentedCharacters(t(b.language_key)) ? 1:-1).map(
                                                (roomSizeType) => (
                                                    <MenuItem key={roomSizeType.id}  value={roomSizeType.code}>
                                                        { t(roomSizeType.language_key) }
                                                    </MenuItem>
                                                )
                                                ) :
                                                (
                                                    <MenuItem>
                                                        { "Data not fount" }
                                                    </MenuItem>
                                                )
                                        }
                                    </SelectValidator>
                                </ColAtm>
                            </Grid>
                            <Grid container spacing={3}>
                                <ColAtm xs={12} md={3}>
                                    <TextValidator
                                        id="roomCount"
                                        name="room_count"
                                        value={this.state.room_count}
                                        placeholder={ t('enw-input-number_of_rooms') }
                                        label={ t('enw-input-number_of_rooms') }
                                        variant="outlined"
                                        onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9]/g, '') }}
                                        fullWidth
                                        autoComplete="off"
                                        onChange={this.handleChangeFields}
                                        validators={['minNumber:1', 'maxNumber:999']}
                                        errorMessages={[ 'minNumber 1', 'maxNumber 999']}
                                    />
                                </ColAtm>
                                <ColAtm xs={12} md={3}>
                                    <TextValidator
                                        id="loungeCount"
                                        name="lounge_count"
                                        value={this.state.lounge_count}
                                        placeholder={ t('enw-input-number_of_lounge') }
                                        label={ t('enw-input-number_of_lounge') }
                                        variant="outlined"
                                        onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9]/g, '') }}
                                        fullWidth
                                        autoComplete="off"
                                        onChange={this.handleChangeFields}
                                        validators={['minNumber:1', 'maxNumber:99', 'matchRegexp:^[1-99][0-99]?$|^99$']}
                                        errorMessages={[ 'minNumber 1', 'maxNumber 99', 'yalnızca sayı']}
                                    />
                                </ColAtm>
                                <ColAtm xs={12} md={3}>
                                    <TextValidator
                                        id="bathroomCount"
                                        name="bathroom_count"
                                        value={this.state.bathroom_count}
                                        placeholder={ t('enw-input-number_of_bathrooms') }
                                        label={ t('enw-input-number_of_bathrooms') }
                                        variant="outlined"
                                        onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9]/g, '') }}
                                        fullWidth
                                        autoComplete="off"
                                        onChange={this.handleChangeFields}
                                        validators={['minNumber:1', 'maxNumber:99', 'matchRegexp:^[1-99][0-99]?$|^99$']}
                                        errorMessages={[ 'minNumber 1', 'maxNumber 99', 'yalnızca sayı']}
                                    />
                                </ColAtm>
                                <ColAtm xs={12} md={3}>
                                    <FormControl variant="outlined" fullWidth>
                                        <Autocomplete
                                            id="max_child_number"
                                            options={ages}
                                            getOptionLabel={option => String(option)}
                                            defaultValue={ isDefined(this.state.max_child_number) ? this.state.max_child_number : ""}
                                            onChange={(e, value) => this.handleChangeMaxChildFields(e, String(value))}
                                            renderInput={params => {
                                                return (
                                                    <TextField
                                                        className={"auto-complete-select"}
                                                        fullWidth
                                                        {...params}
                                                        label={ t('enw-input-max_child_number') }
                                                        variant="outlined"
                                                    />
                                                );
                                            }}
                                        />
                                    </FormControl>
                                </ColAtm>
                            </Grid>
                            {/*<Grid container spacing={3}>
                                <ColAtm xs={12} md={4}>
                                    <TextValidator
                                        id="toiletCount"
                                        name="toilet_count"
                                        value={ this.state.toilet_count }
                                        placeholder={ t('enw-input-number_of_toilets') }
                                        label={ t('enw-input-number_of_toilets') }
                                        variant="outlined"
                                        onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9]/g, '') }}
                                        fullWidth
                                        autoComplete="off"
                                        onChange={this.handleChangeFields}
                                        validators={['minNumber:1', 'maxNumber:99', 'matchRegexp:^[1-99][0-99]?$|^99$']}
                                        errorMessages={[ 'minNumber 1', 'maxNumber 99', 'yalnızca sayı']}
                                    />
                                </ColAtm>
                            </Grid>*/}
                            <ColAtm xs={12}>
                                <Autocomplete
                                    className="auto-complete-select"
                                    onChange={this.handleChangeRoomViewType}
                                    multiple
                                    fullWidth
                                    options={this.props.roomViewTypes.sort((a, b) => convertAccentedCharacters(t(a.language_key)) > convertAccentedCharacters(t(b.language_key)) ? 1:-1)}
                                    defaultValue={  viewTypeReturn(this.props.roomViewTypes, this.state.roomViewType)  }
                                    getOptionLabel={ (option) => t(option.language_key)}
                                    filterSelectedOptions
                                    filterOptions={createFilterOptions({
                                        matchFrom: 'start',
                                        stringify: option => t(option.language_key),
                                    })}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            fullWidth
                                            label={ t('enw-input-room_view') }
                                            placeholder={ t('enw-input-room_view') }
                                        />
                                    )}
                                />
                            </ColAtm>
                        </ColAtm>
                        <ColAtm className="d-block brand-container room-desc">
                            <ColAtm>
                                <AppBar className="room-rate-tab-title" position="static">
                                    <Tabs className="room-rate-tabFont"
                                          value={this.state.tabValue}
                                          onChange={this.handleTabChange}
                                          aria-label="room-rate-tab"
                                          variant="scrollable"
                                          scrollButtons="on"
                                    >
                                        {descriptionTabs}
                                    </Tabs>
                                </AppBar>
                                {descriptionList}
                            </ColAtm>
                        </ColAtm>
                        <ColAtm className="mt-13 assign-rate-next" xs={12}>
                            <BlockAtm className="t-center pb-32" xs={12}>
                                <Tabs className="room-rate-tabFont" value={value} onChange={this.handleChange} aria-label="room-rate-tab">
                                    <Tab label="Rate Plan Detail" {...a11yProps(0)} />
                                    <ButtonAtm type='submit'  buttontext={ t('btn-next') } {...a11yProps(1)} />
                                </Tabs>
                            </BlockAtm>
                        </ColAtm>
                    </TabPanel>
                    <TabPanel value={value} index={1} className="mt-22">
                        {
                            this.props.updateError && isDefined(this.props.updateError) && isDefined(this.props.updateError.response)  ?
                                <ColAtm className="t-center pb-14 update-room-error" md={12}>
                                    <Alert severity="error">{ this.props.updateError.response.data.message }</Alert>
                                </ColAtm>
                                :
                                ""
                        }

                        <ColAtm className="max-room-info" container justify="space-between">
                            <Grid container spacing={3} className="occupancy-box mobile-no-spacing">
                                <ColAtm xs={12} md={4}>
                                    <TextValidator
                                        id="adults"
                                        name="maxAdults"
                                        value={this.state.maxAdults}
                                        placeholder={ t('enw-input-max_adults') }
                                        variant="outlined"
                                        autoComplete="off"
                                        onChange={ (e) => this.handleChangeOccupancy(e) }
                                        onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9]/g, '') }}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <HtmlTooltip
                                                        title={
                                                            <React.Fragment>
                                                                <LabelAtm labelClass="occupancy-desc" text={ t('enw-input-max_adults-description') } />
                                                            </React.Fragment>
                                                        }
                                                    >
                                                        <Button><i className="fas fa-male" /></Button>
                                                    </HtmlTooltip>
                                                </InputAdornment>
                                            ),
                                        }}
                                        validators={['required','minNumber:0', 'maxNumber:30', 'matchRegexp:^[0-9][0-9]?$|^30$']}
                                        errorMessages={[t("enw-notification_this_is_required"),'minNumber 0', 'maxNumber 30', 'yalnızca sayı']}
                                    />
                                </ColAtm>
                                <ColAtm xs={12} md={4}>
                                    <TextValidator
                                        id="children"
                                        name="maxChildren"
                                        placeholder={ t('enw-input-max_children') }
                                        variant="outlined"
                                        autoComplete="off"
                                        value={this.state.maxChildren}
                                        onChange={(e) => this.handleChangeOccupancy(e)}
                                        onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9]/g, '') }}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <HtmlTooltip
                                                        title={
                                                            <React.Fragment>
                                                                <LabelAtm labelClass="occupancy-desc" text={ t('enw-input-max_children-description') } />
                                                            </React.Fragment>
                                                        }
                                                    >
                                                        <Button><i className="fas fa-child" /></Button>
                                                    </HtmlTooltip>
                                                </InputAdornment>
                                            ),
                                        }}
                                        validators={['required','minNumber:0', 'maxNumber:30', 'matchRegexp:^[0-9][0-9]?$|^30$']}
                                        errorMessages={[ t("enw-notification_this_is_required"),'minNumber 0', 'maxNumber 30', 'yalnızca sayı']}
                                    />
                                </ColAtm>
                                <ColAtm xs={12} md={4}>
                                    <TextValidator
                                        id="occupancy"
                                        name="maxRoomOccupancy"
                                        variant="outlined"
                                        autoComplete="off"
                                        placeholder={ t('enw-input-max_room_occupancy') }
                                        onChange={(e) => this.handleChangeOccupancy(e)}
                                        onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9]/g, '') }}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <HtmlTooltip
                                                        title={
                                                            <React.Fragment>
                                                                <LabelAtm labelClass="occupancy-desc" text={ t('enw-input-max_room_occupancy-description') } />
                                                            </React.Fragment>
                                                        }
                                                    >
                                                        <Button><i className="fas fa-users" /></Button>
                                                    </HtmlTooltip>
                                                </InputAdornment>
                                            ),
                                        }}
                                        value={this.state.maxRoomOccupancy}
                                        validators={['required','minNumber:0', 'maxNumber:30', 'matchRegexp:^[1-9][0-9]?$|^30$']}
                                        errorMessages={[ t("enw-notification_this_is_required"),'minNumber 0', 'maxNumber 30', 'yalnızca sayı']}
                                    />
                                </ColAtm>
                            </Grid>
                            <ColAtm style={{display: 'inherit'}} className="mt-32 occupancy-height">
                                {
                                    Object.keys(occupancyCode).length > 0 ?
                                        occupancyCode.map( (occupancy) => (
                                            <Button
                                                className={this.state.exclude_occupancy.includes(occupancy.code) ? "select-occupancy" : "deselect-occupancy"  }
                                                type="button"
                                                onClick={ () => this.handleChangeExcludeOccupancy(occupancy.code) }
                                            >
                                                {ReactHtmlParser(occupancy.icon)}
                                            </Button>
                                        )) : ''
                                }
                            </ColAtm>
                            <LabelAtm
                                labelClass="select-room-type-text"
                                text={ t('enw-room-rooms-modal-room_type-sub_description') }
                            />
                        </ColAtm>

                        <Grid sm={12} className="select-room-types mt-22 mb-12">
                            <Grid container spacing={2}>
                                <Grid item>
                                    <FormControlLabel
                                        className="color-black"
                                        name="noPass"
                                        control={<Checkbox color="primary" value={this.state.occupancy_lock} defaultChecked={this.state.occupancy_lock === null ? false : true} id="1" />}
                                        label={ t('enw-input-occupancy_lock') }
                                        labelPlacement="left"
                                        onClick={this.handleOccupancyLock}
                                    />
                                </Grid>
                                <ColAtm>
                                    <LabelAtm variant="h6" component="h3" text={ t('enw-connected_room-info') } />
                                </ColAtm>
                                <Grid item>
                                    <input type={"radio"} name={"notConnectedRoom"}
                                           id={"notConnectedRoom"}
                                           value={"false"}
                                           className="d-none"
                                           checked={ !is_connected_room }
                                           onClick={(e) => { this.setState({is_connected_room: false}) }}
                                    />
                                    <label className="show-channel-detail"
                                           htmlFor={"notConnectedRoom"}>
                                        { t('enw-input-checkbox-no') }
                                    </label>
                                </Grid>
                                <Grid item>
                                    <input type={"radio"} name={"connectedRoom"}
                                           id={"connectedRoom"}
                                           value={"true"}
                                           className="d-none"
                                           onClick={(e) => { this.setState({is_connected_room: true}) }}
                                           checked={ is_connected_room }
                                    />
                                    <label className="show-channel-detail" htmlFor={"connectedRoom"}>
                                        { t('enw-input-checkbox-yes') }
                                    </label>

                                </Grid>
                            </Grid>
                        </Grid>

                        {
                            is_connected_room &&
                            <ColAtm className="select-room-types mb-24">
                                <ColAtm>
                                    <Autocomplete
                                        style={{width: '100%'}}
                                        id="tags-outlined"
                                        options={this.props.rooms.sort((a, b) => convertAccentedCharacters(a.name) > convertAccentedCharacters(b.name) ? 1:-1)}
                                        getOptionLabel={option => option.name}
                                        multiple
                                        defaultValue={ viewTypeReturn(this.props.rooms, this.props.roomInfo?.property_room_connected.map(connectedRooms => connectedRooms.connected_room_id)) }
                                        onChange={(options, value) => {this.selectedRooms(value)} }
                                        renderInput={params => (
                                            <TextField
                                                {...params}
                                                variant="outlined"
                                                label={ t('enw-input-room') }
                                                placeholder={ t('enw-input-room') }
                                                fullWidth
                                            />
                                        )}
                                    />
                                </ColAtm>
                                <ColAtm md={3} className="mt-22 d-block">
                                    <FormControlLabel
                                        className="desc-text"
                                        name="is_connected_room_price"
                                        control={<Checkbox color="primary" value="is_connected_room_price" defaultChecked={is_connected_room_price} />}
                                        label={ t('enw-connected_room-price') }
                                        labelPlacement="left"
                                        onChange={() => { this.setState({is_connected_room_price: !is_connected_room_price}) }}
                                    />
                                </ColAtm>
                                <ColAtm md={3} className="mt-22 d-block">
                                    <FormControlLabel
                                        className="desc-text"
                                        name="is_connected_room_availability"
                                        control={<Checkbox color="primary" value="is_connected_room_availability" defaultChecked={is_connected_room_availability} />}
                                        label={ t('enw-connected_room-availability') }
                                        labelPlacement="left"
                                        onChange={() => { this.setState({is_connected_room_availability: !is_connected_room_availability}) }}
                                    />
                                </ColAtm>
                            </ColAtm>

                        }

                        {
                            this.state.options.map( (option,id) => (
                                <BlockAtm>
                                    <ColAtm>
                                        <LabelAtm labelClass="bed-type-title ml-8" text={ t('enw-room-rooms-modal-bed_type-title') + ' ' + (id + 1) } />
                                        { id > 0 &&
                                        <ColAtm xs={1} className="form-group mr-9" style={{ paddingTop:10}}>
                                            <ButtonAtm className="delete-bed-button" fullwidth={true}
                                                       startIcon={<i className="fas fa-minus-circle" />}
                                                       onClick={this.handleDeleteOptionField(id)}
                                            />
                                        </ColAtm>
                                        }
                                        {
                                            option.map( (el,subId) => (
                                                <ColAtm xs={11} className="select-room-types" key={subId} id={subId}>
                                                    <ColAtm md={12} className="form-group general-select">
                                                        <FormControl variant="outlined" fullWidth className="MuiGrid-item MuiGrid-grid-xs-10 MuiGrid-grid-md-11">
                                                            <InputLabel>{ t('enw-input-bed_type') }</InputLabel>
                                                            <Select value={el.bed_type_id} className="form-control" label={ t('enw-input-bed_type') } onChange={this.handleChangeBedType(id,subId)}>
                                                                {
                                                                    this.props.allBedType.sort((a, b) => convertAccentedCharacters(t(a.language_key)) > convertAccentedCharacters(t(b.language_key)) ? 1:-1).map( (bedType) => (
                                                                        <MenuItem value={ bedType.id } description="Beds">
                                                                            <img className="bed-type-icons" src={"/assets/img/icons/bed-icons/" + (bedType.icon)} /> { t(bedType.language_key) }
                                                                        </MenuItem>
                                                                    ))
                                                                }

                                                            </Select>
                                                        </FormControl>
                                                        <ColAtm xs={1} className="form-group pt-24">
                                                            <ButtonAtm className={option.length > 1 ? "delete-bed-button" : "d-none"}  fullwidth={true}
                                                                       startIcon={<i className="fas fa-minus-circle" />}
                                                                       id={subId}
                                                                       onClick={() => this.handleDeleteFields(subId, id) }
                                                            />

                                                        </ColAtm>
                                                    </ColAtm>
                                                </ColAtm>
                                            ))
                                        }
                                        <ColAtm md={1} className="form-group pt-24 new-bed-type">
                                            <ButtonAtm className="new-bed-button" fullwidth={true}
                                                       startIcon={<i className="fas fa-plus-circle" />}
                                                       onClick={this.handleAddField(id)}
                                            />
                                        </ColAtm>
                                    </ColAtm>

                                    <ColAtm className="bed-type-info" container>
                                    </ColAtm>
                                </BlockAtm>
                            ) )
                        }

                        <ColAtm>
                            <BlockAtm className="t-center pb-32" xs={12}>
                                <ButtonAtm
                                    className="room-rate-add soft-blue-button m-auto radius-8"
                                    type="button"
                                    buttontext={ t('btn-add_bedding_option') }
                                    startIcon={<i className="fas fa-plus-circle" />}
                                    onClick={this.handleAddOptions}
                                />
                            </BlockAtm>
                            <BlockAtm xs={12} className="t-center">
                                <ButtonAtm
                                    className="room-rate-modal-save room-rate-save bg-red m-auto"
                                    buttontext={ t('btn-save') }
                                    autoFocus
                                    color="primary"
                                    type="submit"
                                    onClick={this.handleRoomAdd}
                                />
                            </BlockAtm>
                        </ColAtm>
                    </TabPanel>
                </ValidatorForm>
                <Snackbar
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    open={showSnackbar}
                    autoHideDuration={3000}
                    onClose={this.handleCloseSnackbar}
                >
                    <Alert onClose={this.handleCloseSnackbar} severity="success">
                        {t('enw-translated_to_all_languages')}
                    </Alert>
                </Snackbar>
                <style>{`
                    .desc-field {
                        margin-top:8px !important;
                    }
                `}</style>
            </div>
        );
    }
}

EditRoomForm.propTypes = {};

const mapStateToProps = (props) => {
    return{
        updateError : props.propertyRoomAndRateReducers.updateError,
        openAIResult: props.openAIReducer?.listData,
        languageList: props.languagesReducer?.languages,
        propertyProductsReducer: props.propertyProductsReducer,
    }
}

export default compose(withTranslation('common')) ( connect(mapStateToProps, { openAI, clearOpenAI, getLanguages, propertyProducts } )(EditRoomForm));
